import { render } from "./CreateCategoryDialog.vue?vue&type=template&id=ac0047fa"
import script from "./CreateCategoryDialog.vue?vue&type=script&lang=js"
export * from "./CreateCategoryDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__